module.exports = __webpack_public_path__ + "media/images/flags/FI-69258c9db8186362350930688515b5fa.svg";